import React, { useState } from 'react';
import moment from 'moment';

import { env } from '~/commons/config';

import ListResource from './ListResource.jsx';
import BtnDayRangePicker from '../btns/BtnDayRangePicker.jsx';

const api = '/api/core/stocks/records';

const ListStockRecords = () => {
  const [createdDate, setCreatedDate] = useState(null);

  return (
    <ListResource
      {...{
        searchable: [
          { value: 'target', label: 'Stock' },
          { value: 'user', label: 'User' },
        ],
        api,
        filter: {
          ...(createdDate && { createdAt: createdDate }),
        },
        sort: { createdAt: -1 },
        actions: {
          fileExport: true,
          create: false,
          remove: false,
        },
        cols: [
          {
            key: 'target.itemCode',
            sortable: true,
            children: 'Item Code',
          },
          {
            key: 'target.serialNo',
            sortable: true,
            children: 'Serial Nubmer',
          },
          {
            key: 'target.status',
            sortable: true,
            children: 'Current Status',
          },
          {
            key: 'user',
            children: 'Action By',
            sortable: true,
            getter: (v, r) => (r.bySystem ? 'CMS Auto' : v?.username) || '',
          },
          {
            key: 'action',
            sortable: true,
          },
          {
            key: 'createdAt',
            children: 'Action At',
            sortable: true,
            getter: (v) => moment(v).format(env.f.dt),
          },
          {
            key: 'target.onHoldReleaseAt',
            children: 'Auto Release Date',
            getter: (v, r) => (r.action === 'OnHold' && v ? moment(v).format(env.f.d) : ''),
          },
        ],
      }}>
      {() => (
        <>
          <BtnDayRangePicker
            className="float-right"
            value={createdDate}
            onChange={setCreatedDate}
            placeholder={'Created At'}
          />
        </>
      )}
    </ListResource>
  );
};

export default ListStockRecords;
